import { api, LightningElement } from "lwc";
import { Certification } from "tbme/certifications";
export default class extends LightningElement {
  @api certification?: Certification;
  @api isSelf: boolean = false;
  _statusColor = "";
  _htmlBody = "";

  get statusColor() {
    return `color: var(${this.certification?.status.color})`;
  }

  get htmlBody() {
    return `<span class="html-body text_heavy">${this.certification?.title}</span>`;
  }

  get containerClass() {
    return this.certification?.hasDivider
      ? `container container_underline`
      : `container`;
  }

  get maintenanceDueDate() {
    return this.certification?.maintenanceDueDate
      ? `on ${this.certification.maintenanceDueDate}`
      : null;
  }

  get completedExpiredDate() {
    return this.certification?.dateExpired &&
      this.certification.status.title === "Expired"
      ? `Expired ${this.certification.dateExpired}`
      : `Issued ${this.certification?.dateCompleted}`;
  }

  get showActionButton() {
    return !!this.certification?.maintenanceDueDate && this.isSelf;
  }

  connectedCallback(): void {
    console.log(this.certification);
  }
}
